// extracted by mini-css-extract-plugin
export default {"contentModal":"AdminDialog_contentModal__UV+Y6","contentModalBtn":"AdminDialog_contentModalBtn__Vl4p9","list":"AdminDialog_list__5kM01"};